module.exports = __webpack_public_path__ + "static/img/09.772b97b0.png";